export const NUMBER_PARSER_TYPE = 'number' as const
export const NUMBER_EXPECTATION = NUMBER_PARSER_TYPE

export const STRING_PARSER_TYPE = 'string' as const

export const OBJECT_PARSER_TYPE = 'object' as const

// we only define these, because they are the ones we use in code and check for
export const TYPES = [OBJECT_PARSER_TYPE, STRING_PARSER_TYPE, NUMBER_PARSER_TYPE]
